import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PopoverMultiSelectObjectBaseComponent} from '../_base/popover-multi-select-object-base.component';
import {
  Tile,
  TILE_FORMAT_MULTICHOICE,
  TILE_FORMAT_NUMERIC,
  TILE_FORMAT_TOGGLE,
  TileFormat,
  TileId,
} from '../../../../../shared/models/tile';
import {TilesService} from '../../../../../core/services/tiles.service';
import {Observable} from 'rxjs';
import {Option, OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {PopoverMultiSelectComponent} from '../../popover-multi-select.component';

@Component({
  selector: 'motn-popover-select-tiles',
  templateUrl: './popover-select-tiles.component.html',
  styleUrls: ['./popover-select-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMultiSelectComponent,
  ],
})
export class PopoverSelectTilesComponent extends PopoverMultiSelectObjectBaseComponent implements OnInit {
  @Input() preselectedTileId: TileId;
  @Input() preselectedTileIds: TileId[] = [];

  /**
   * Optional. Supply if there should only be a subset of tiles smaller than all the
   * user's tiles to select from.
   */
  @Input() tiles: Tile[];

  /**
   * Optional.
   */
  @Input() permittedFormat: TileFormat;


  constructor(
    private tilesService: TilesService,
  ) {
    super();
  }


  protected onInit() {
    this.optionGroup$ = new Observable<OptionGroupMultiSelect>(
      subscriber => {
        if (this.optionGroupIsPrepared()) {
          this.initSubscriberHandle(subscriber);
        } else if (!this.tiles) {
          this.tilesService.fetchUserTiles$().subscribe({
            next: (tiles) => {
              this.tiles = tiles;

              this.prepareOptionGroup();
              this.initSubscriberHandle(subscriber);
            },
            error: err => subscriber.error(err),
          });
        } else {
          this.prepareOptionGroup();
          this.initSubscriberHandle(subscriber);
        }
      },
    );
  }


  onSelectTile($event: Option) {
    if ($event) {
      this.clickedOption$.emit($event);
    }
  }


  protected prepareOptionGroup(): OptionGroupMultiSelect {
    const options: Option[] = [];

    for (let tile of this.tiles) {
      if (this.permittedFormat) {
        switch (tile.Type) {
          case 'SIMPLE_ANALOG':
            if (this.permittedFormat !== TILE_FORMAT_NUMERIC) {
              continue;
            }
            break;
          case 'SIMPLE_BOOL':
            if (this.permittedFormat !== TILE_FORMAT_TOGGLE) {
              continue;
            }
            break;
          case 'SIMPLE_MULTISTATE':
            if (this.permittedFormat !== TILE_FORMAT_MULTICHOICE) {
              continue;
            }
            break;
          default:
            continue;
        }
      }

      const facets = tile.facets;
      options.push({
        id: '' + tile.ID,
        name: tile.Name,
        subtitle: facets.length ? facets.map(f => f.Value).join(' · ') : undefined,
        selected: this.preselectedTileIds.includes(tile.ID) || tile.ID === this.preselectedTileId,
        pill: {
          letter: 't',
          text: tile.ID,
        },
      });
    }

    return this.optionGroup = new OptionGroupMultiSelect(options);
  }
}
